import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { useAppDispatch, useAppSelector } from "store/hooks/hooks";
import { selectIsAuthenticated, selectUser } from "store/slices/authSlice";
import {
  selectIsUserTerminated,
  setIsUserTerminated,
} from "store/slices/uiSlice";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const hasShownToast = useRef(false);
  const isUserTerminated = useAppSelector(selectIsUserTerminated);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isAuthenticated && !hasShownToast.current) {
      if (!isUserTerminated) {
        toast.error("You must log in to access this page");
      }

      hasShownToast.current = true;

      if (isUserTerminated) {
        dispatch(setIsUserTerminated(false));
      }
    }

    if (isAuthenticated) {
      hasShownToast.current = false;
    }
  }, [isAuthenticated, dispatch, isUserTerminated]);

  return isAuthenticated ? (
    <>{children}</>
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default ProtectedRoute;
